// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PlusIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PlusIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 10.75v5.75h1.5v-5.75h5.75v-1.5h-5.75V3.5h-1.5v5.75H3.5v1.5z" />
    </SvgIcon>
  );
});

/**
 * Use to add or create something
 * @public
 */
export const PlusIcon = /* @__PURE__ */ Object.assign(PlusIconComponent, {
  displayName: 'PlusIcon',
});
